import http from "@/request"

/**
 * 获取单位列表
 * @param {*} param 
 * @returns 
 */
export function listProcess(data) {
    return http({
        url: "/process/list",
        method: "post",
        data: data
    });
}

/**
 * 设置发票级批次状态
 * @param {*} data 
 * @returns 
 */
export function settingReimbursed(data) {
    return http({ 
        url: "/process/setting/reimbursed",
        method: "post",
        data: data
    });
}

/**
 * 取消标记
 * @param {*} data 
 * @returns 
 */
export function settingUnReimbursed(data) {
    return http({
        url: "/process/setting/unreimbursed",
        method: "post",
        data: data
    });
}

/**
 * 发票认领
 * @param {*} data 
 * @returns 
 */
export function invoiceClaim(data) {
    return http({
        url: "/process/invoiceClaim",
        method: "post",
        data: data
    });
}

/**
 * 退回
 * @param {*} data 
 * @returns 
 */
export function settingReturn(data) {
    return http({
        url: "/process/setting/return",
        method: "post",
        data: data
    });
}
export function auditBatch(data) {
    return http({
        url: "process/auditBatch",
        method: "post",
        data: data
    });
}


// WEBPACK FOOTER //
// ./src/api/process.js